import React, { useEffect, useState } from 'react';


import RoutesLazy from '../src/Routes/index'
import axios from 'axios';
import { CssBaseline } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js'
import 'react-toastify/dist/ReactToastify.css';
import 'rsuite/dist/rsuite.min.css';
import { useDispatch, useSelector } from 'react-redux';
import Loader from './components/layout/Loader/Loader';
import { toast, ToastContainer } from 'react-toastify';
import Layout from './components/layout/Layout';
import { setisLoginUser, setLoader, setToken, setUserData } from './redux/features/authSliceandSidebar';
import { useNavigate } from 'react-router-dom';

// const RoutesLazy = React.lazy(() => import('./Routes/index'))


export var common_axios = axios.create({
  baseURL: `https://track-api.altruistindia.com`
  // baseURL: `https://track-dev-api.altruistindia.com`,
  // timeout: 10000,
})






function App() {

  const navigate = useNavigate()

  const loader = useSelector((x) => x.authSliceandSidebar.loader)
  const isLogin = useSelector((x) => x.authSliceandSidebar.isLogin)
  if (localStorage.getItem('user') != null) {
    common_axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem('token')}`;
    common_axios.defaults.headers.common["userId"] = localStorage.getItem('userId');
    common_axios.defaults.headers.common["jwtToken"] = localStorage.getItem('token');
    common_axios.defaults.headers["source"] = '1'
    common_axios.defaults.headers["appVersion"] = '0'
  }

  const dispatch = useDispatch();


  useEffect(() => {
    if (localStorage.getItem('token') != null) {
      dispatch(setUserData(JSON.parse(localStorage.getItem('user'))));
      dispatch(setisLoginUser(true));
      dispatch(setToken(localStorage.getItem('token')));
      // common_axios.defaults.headers.common["Authorization"] = `Bearer ${localStorage.getItem('token')}`;
      // common_axios.defaults.headers.common["userId"] = localStorage.getItem('userId');
      // common_axios.defaults.headers.common["jwtToken"] = localStorage.getItem('token');
      // common_axios.defaults.headers["source"] = '1'
      // common_axios.defaults.headers["appVersion"] = '0'
      // console.log(common_axios.defaults.headers)
    }
    else {
      dispatch(setisLoginUser(false));
      dispatch(setUserData(null));
    }
  }, [])


  useEffect(() => {

    if (localStorage.getItem('user') != null) {
      // common_axios.defaults.headers.common["content-type"] = 'application/json';

      // common_axios.defaults.headers.common["jwtToken"] = localStorage.getItem('token');
      // common_axios.defaults.headers["source"] = '1'
      // common_axios.defaults.headers["appVersion"] = '0'
    }
    else {
      // common_axios.defaults.headers.common["Authorization"] = null;
      // common_axios.defaults.headers.common["userId"] = null;
      // common_axios.defaults.headers.common["jwtToken"] = null;
      // common_axios.defaults.headers["source"] = '1'
      // common_axios.defaults.headers["appVersion"] = '0'
    }
  }, [isLogin])


  common_axios.interceptors.request.use((config) => {
    if (config.skipAuth) {
      // if (config.url.includes('/'))
      return config; // Don't add common headers
    }    // Add common headers
    config.headers["Authorization"] = `Bearer ${localStorage.getItem("token")}`;
    config.headers["userId"] = localStorage.getItem("userId");
    config.headers["jwtToken"] = localStorage.getItem('token');
    // config.headers["jwtToken"] = localStorage.getItem("jwtToken");
    return config;
  });

  common_axios.interceptors.response.use(
    async (config) => {



      if (!navigator.onLine) {
        toast.error('No Internet connection');
        dispatch(setLoader(false))
        localStorage.clear();
        navigate('/')
        return Promise.reject(new Error('No Internet connection'));
      }
      if (!config) {
        localStorage.clear();
        if (!toast.isActive('sdfsdfsdfsdfsdfsd')) {
          toast.error("Session Expired")
        }
        navigate('/')
        dispatch(setLoader(false))
        // dispatch(setSidebarOpen(false))
        dispatch(setisLoginUser(false))
        // dispatch(setTabIndex(""))
        window.location.reload(true)
        return config
      }


      if (config && config?.data?.statusDescription?.statusCode == 403 || config?.data?.statusDescription?.statusCode == 401) {
        if (!toast.isActive('sdfsdfsdfsdfsdfsd')) {
          toast.error(config?.data?.statusDescription?.description, {
            toastId: "sdfsdfsdfsdfsdfsd", // Ensures this toast doesn't appear multiple times
          })
        }
        navigate('/')
        dispatch(setLoader(false))
        localStorage.clear();
        // dispatch(setSidebarOpen(false))
        window.location.reload(true)
        // dispatch(setTabIndex(""))

      }

      return config
    },
    error => {
      // // console.log(error)
      Promise.reject(error)

    }
  )



  return <>
    <CssBaseline />

    {
      isLogin ? <Layout >
        <RoutesLazy />
      </Layout> : <RoutesLazy />
    }




    {
      <Loader />
    }
    <ToastContainer autoClose={2000} />
  </>

    ;
}

export default App;

